import React from 'react';
import styles from './Footer.module.scss'
import FooterButton from "../FooterButton/FooterButton";
import CreateReceiptButton from "../../CreateReceipt/CreateReceipt";
import {HomeRounded, PeopleAltRounded, PersonRounded, ReceiptLongRounded} from "@mui/icons-material";
import {Fragment} from "preact";

interface FooterProps {
  isVisible: boolean
}

const Footer = ({isVisible}: FooterProps) => {

  return (
    <Fragment>
      {isVisible &&
        <nav className={styles['footer']} aria-label="Primary">
          <FooterButton Icon={HomeRounded} mainRoute={"/home"} label="Home"/>

          <FooterButton Icon={PeopleAltRounded} mainRoute={"/groups"}
                        routes={["/groups/details"]} label="Groups"/>

          <CreateReceiptButton/>

          <FooterButton Icon={ReceiptLongRounded} mainRoute={"/receipts"} routes={["/receipt"]} label="History"/>

          <FooterButton Icon={PersonRounded} mainRoute={"/profile"} label="Profile"/>
        </nav>
      }
    </Fragment>
  )
}

export default Footer;
